import type { ReactNode } from 'react'
import type { IOrder } from '../../../Model/index.js'
import { ScopeNotFoundNotice } from '../../Component/ScopeNotFoundNotice.tsx'
import { useScopeOwner } from './useScopeOwner.ts'

type ScopeOwnerGateProps = {
  type: 'PROJECT' | 'ORDER'
  id: string | undefined
  /** Off: renders [children] straight away, without asking for the owner. */
  enabled: boolean
  loading: ReactNode
  /** Rendered only once the owner is found, so nothing below asks the viz endpoints for a scope the user may not see. */
  children: (order: IOrder | null) => ReactNode
}

/** Renders a scope's data views once its project or order is found, the not-found notice when it answered 404. */
export function ScopeOwnerGate({ type, id, enabled, loading, children }: ScopeOwnerGateProps) {
  const owner = useScopeOwner(type, id, enabled)
  if (owner.status === 'notFound') {
    return <ScopeNotFoundNotice scopeKind={type === 'PROJECT' ? 'project' : 'order'} />
  }
  if (owner.status === 'loading') {
    return <>{loading}</>
  }
  return <>{children(owner.order)}</>
}
